import { Availability } from "@caredna-marlin/utils/client/availability";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Checkbox, Collapse, IconButton, TableCell, TableRow, useTheme } from "@mui/material";
import { Dictionary, startCase } from "lodash";
import { AvailabilityByTimespanQuery } from "~/graphql/__generated__/graphql";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import AvailabilityTable from "./AvailabilityTable";

type Props = {
  availability: Availability[],
  highlightAvailability?: number[],
  provider: AvailabilityByTimespanQuery["provider"][number],
  teams: Dictionary<AvailabilityByTimespanQuery["team"][number]>,
  expanded: boolean,
  setExpanded: (e: boolean) => void,
  index: number,

  selected: boolean,
  setSelected: (selected: boolean) => void,
}

const ProviderSelectableTableRow = ({ availability, expanded, index, highlightAvailability, provider, selected, setExpanded, setSelected, teams }: Props) => {
  const { providerTypes, serviceLines } = useOrgConfig();

  const theme = useTheme();
  const background = index % 2 ? theme.palette.grey[200] : undefined;

  const teamNames = provider.teamProviders.map(tp => teams[tp.teamId]?.name).filter(Boolean);
  const serviceLineNames = provider.serviceLineProviders.map(slp => serviceLines[slp.serviceLineId]?.name).filter(Boolean);

  return <>
    <TableRow sx={{ background, "td": { borderBottom: "none" }}} selected={selected}>
      <TableCell onClick={() => setSelected(!selected)} sx={{ cursor: "pointer", p: 0 }}>
        <Checkbox checked={selected} />
      </TableCell>
      <TableCell sx={{ cursor: "pointer", pl: 0 }} onClick={() => setExpanded(!expanded)}>
        <IconButton aria-label="Expand row" size="small" disableRipple>
          {expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
        </IconButton>
        {provider.firstName} {provider.lastName}
      </TableCell>
      <TableCell>{startCase(providerTypes[provider.providerTypeId]?.name)}</TableCell>
      <TableCell>{provider.addressStreet}, {provider.addressCity}, {provider.addressState}</TableCell>
      <TableCell>{serviceLineNames.join(", ")}</TableCell>
      <TableCell>{teamNames.join(", ")}</TableCell>
    </TableRow>
    <TableRow sx={{ background }}>
      <TableCell colSpan={6} sx={{ p: 0 }}>
        <Collapse in={expanded} timeout="auto" unmountOnExit sx={{pl: 11, pb: 1}}>
          <AvailabilityTable availability={availability} setEditing={null} selected={highlightAvailability} />
        </Collapse>
      </TableCell>
    </TableRow>
  </>
}

export default ProviderSelectableTableRow;
